import { render, staticRenderFns } from "./ysMenu.vue?vue&type=template&id=13deeafe&"
import script from "./ysMenu.vue?vue&type=script&lang=js&"
export * from "./ysMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports